import { getConfig } from '@/modules/common/helpers/config';
import { API_TIMEOUTS } from '../constant';
import { IPimApiConnector } from './IPimApiConnector';
import { BaseConnector } from '@/modules/api/BaseConnector';
import { ValidAssetType } from '@/modules/vehicles';

import {
  transformRestVehiclesToVehicles,
  UnifiedVehicle,
  convertRestLoadCarrierToModel,
  LoadCarrier,
  FileReferenceResponse,
} from './mapper';

export class PimApiConnector extends BaseConnector implements IPimApiConnector {
  private static instance: PimApiConnector;
  private static baseUrl = getConfig().api.pimService.url;
  private static scopes = [getConfig().api.pimService.scope];

  public static getInstance(): IPimApiConnector {
    if (!PimApiConnector.instance) {
      PimApiConnector.instance = new PimApiConnector();
    }
    return PimApiConnector.instance;
  }

  private constructor() {
    super(PimApiConnector.baseUrl, PimApiConnector.scopes, API_TIMEOUTS.pimService);
  }

  public async getAllUnifiedVehicles(): Promise<UnifiedVehicle[]> {
    const result = await this.get<Parameters<typeof transformRestVehiclesToVehicles>[0]>(
      '/v1/unifiedVehicleTypes',
    );
    return result ? transformRestVehiclesToVehicles(result) : [];
  }

  public async getAllLoadCarriers(): Promise<LoadCarrier[]> {
    const result = await this.get<Parameters<typeof convertRestLoadCarrierToModel>[0][]>(
      '/v1/loadCarriers',
    );
    return result ? result.map(convertRestLoadCarrierToModel) : [];
  }

  public async getUnifiedVehicleAssetUrl(
    vehicleId: string,
    projectId: string,
    layoutAlternativeId: string,
    revisionId: string,
    category: ValidAssetType,
  ): Promise<FileReferenceResponse | null> {
    return (
      (await this.get<FileReferenceResponse>(
        `/v1/unifiedVehicleType/file?vehicleId=${vehicleId}&projectId=${projectId}&layoutAlternativeId=${layoutAlternativeId}&revisionId=${revisionId}${
          category ? `&category=${category}` : ''
        }`,
      )) ?? null
    );
  }

  public async getLoadCarrier(databaseId: number): Promise<LoadCarrier | null> {
    const result = await this.get<Parameters<typeof convertRestLoadCarrierToModel>[0]>(
      `/v1/loadCarriers/${databaseId}`,
    );
    return result ? convertRestLoadCarrierToModel(result) : null;
  }
}
